export default () => ({
  isDesktopPlaying: false,
  isMobilePlaying: false,
  isMobile: false,
  isVideoPlaying: false,
  hidePauseButton: false,

  init() {
    this.updateMobileFlag()
    const { thisParentContainer, desktopVideo, mobileVideo } = this.$refs

    if (desktopVideo && desktopVideo.autoplay) {
      this.isVideoPlaying = true
    }

    desktopVideo.addEventListener("ended", (event) => {
      this.isVideoPlaying = false
    })
  },

  updateMobileFlag() {
    this.isMobile = window.matchMedia("(max-width: 767px)").matches
  },

  playPauseToggle(evt) {
    const { thisParentContainer, desktopVideo, mobileVideo } = this.$refs
    const videoContainers = Array.from(thisParentContainer.querySelectorAll("video"))
    const visibleVideo =
      videoContainers.find((video) =>
        video.checkVisibility ? video.checkVisibility() : video.offsetParent !== null
      ) || videoContainers[0]

    // Autoplayed video runs muted, so the first click turns the sound on instead of pausing
    if (this.isVideoPlaying && visibleVideo && visibleVideo.muted) {
      this.unmuteVideo(videoContainers, visibleVideo)
      return
    }

    if (this.isVideoPlaying) {
      videoContainers.forEach((video) => {
        video.pause()
      })
      this.isVideoPlaying = false
      this.hidePauseButton = true
    } else {
      this.unmuteVideo(videoContainers, visibleVideo)
      videoContainers.forEach((video) => {
        video.play()
      })
      this.isVideoPlaying = true
      this.hidePauseButton = false
    }
  },

  // Only the visible video gets sound, so desktop and mobile videos never play audio together
  unmuteVideo(videos, visibleVideo) {
    videos.forEach((video) => {
      video.muted = video !== visibleVideo
    })
  },
  showPauseButtonOnHover() {
    if (this.isVideoPlaying) {
      this.hidePauseButton = false
    }
  },
  hidePauseButtonOnHover() {
    if (this.isVideoPlaying) {
      this.hidePauseButton = true
    }
  },
})
